import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../auth/AuthContext';
import SidebarLeaderboardSection from './sidebar/SidebarLeaderboardSection';
import SidebarStatsSection from './sidebar/SidebarStatsSection';
import SidebarProfileSection from './sidebar/SidebarProfileSection';

function Sidebar({ drawerOpen, onCloseDrawer, ariaHidden }) {
  const { authenticated, authChecked, openAuth, logout } = useAuth();
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);

  useEffect(() => {
    if (!logoutConfirmOpen) {
      return undefined;
    }
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setLogoutConfirmOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [logoutConfirmOpen]);

  const handleLogoutClick = () => {
    setLogoutConfirmOpen(true);
  };

  const handleCancelLogout = () => {
    setLogoutConfirmOpen(false);
  };

  const handleConfirmLogout = async () => {
    setLogoutConfirmOpen(false);
    await logout();
    onCloseDrawer?.();
  };

  const handleLogin = () => {
    openAuth('signin');
    onCloseDrawer?.();
  };

  return (
    <aside
      id="app-sidebar"
      className={`sidebar${drawerOpen ? ' sidebar--open' : ''}`}
      aria-hidden={ariaHidden ? true : undefined}
    >
      <div className="sidebar-top">
        <SidebarProfileSection onCloseDrawer={onCloseDrawer} />
        <SidebarStatsSection />
        <SidebarLeaderboardSection />
      </div>

      <div className="sidebar-bottom">
        <div className="sidebar-divider" aria-hidden="true" />
        {!authChecked ? (
          <div
            className="sidebar-auth-btn-placeholder"
            aria-busy="true"
            aria-label="Checking sign-in status"
          />
        ) : authenticated ? (
          <button type="button" className="logout-btn" onClick={handleLogoutClick}>
            Logout
          </button>
        ) : (
          <button type="button" className="sidebar-login-btn" onClick={handleLogin}>
            Login
          </button>
        )}
      </div>

      {logoutConfirmOpen
        ? createPortal(
            <div
              className="auth-modal-root logout-confirm-overlay"
              role="presentation"
              onMouseDown={(e) => {
                if (e.target === e.currentTarget) {
                  handleCancelLogout();
                }
              }}
            >
              <div
                className="auth-modal-dialog auth-card logout-confirm-card"
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="logout-confirm-title"
                aria-describedby="logout-confirm-desc"
                onMouseDown={(e) => e.stopPropagation()}
              >
                <h2 id="logout-confirm-title" className="logout-confirm-title">
                  Log out?
                </h2>
                <p id="logout-confirm-desc" className="logout-confirm-desc">
                  You’ll need to sign in again to save runs and use your profile.
                </p>
                <div className="logout-confirm-actions">
                  <button type="button" className="logout-confirm-cancel" onClick={handleCancelLogout}>
                    Cancel
                  </button>
                  <button type="button" className="logout-btn logout-confirm-ok" onClick={handleConfirmLogout}>
                    Log out
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )
        : null}
    </aside>
  );
}

export default Sidebar;
